import { Component, OnInit, computed, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { dispatch, select } from '@ngxs/store';

import { SiPaginationComponent } from '@siemens/element-ng/pagination';
import { SiCardComponent } from '@siemens/element-ng/card';
import { SlicePipe } from '@angular/common';
import { NewsItemComponent } from './news-item/news-item.component';
import { NewsState } from '../../shared/state/news/news.state';
import { LoadNews } from '../../shared/state/news/news.actions';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    imports: [NewsItemComponent, SiPaginationComponent, SiCardComponent, SlicePipe]
})
export class NewsComponent implements OnInit {
    private readonly translateService = inject(TranslateService);
    private readonly loadNews = dispatch(LoadNews);

    protected readonly news = select(NewsState.news);
    protected readonly isLoading = select(NewsState.isLoading);
    protected readonly totalCount = computed(() => this.news().length);
    protected readonly pageSize = 10;
    protected readonly skeletonItems = Array.from({ length: 4 });
    protected currentPage = 1;
    protected sliceStart = 0;
    protected sliceEnd: number = this.pageSize;

    public ngOnInit(): void {
        const language = this.translateService.currentLang() || this.translateService.fallbackLang() || 'en';
        void this.loadNews({ lang: language });
    }

    protected pageSelectedChanged(page: number): void {
        this.currentPage = page;
        this.sliceStart = this.pageSize * (page - 1);
        this.sliceEnd = this.sliceStart + this.pageSize;
    }
}
